import {Side} from './index.h'
import {flipSide, getTurnFromTransition} from './navigation'
import {Transition} from './transition'

export function convertSidesToTransitions(sides: Side[]): Transition[] {
  if (sides.length < 2) throw Error('path is too small')
  const lastSide = sides[sides.length - 1]
  const sidesExtended = [...sides, lastSide]
  const result: Transition[] = []
  for (let i = 0; i < sides.length; i++) {
    const side = sides[i]
    const nextSide = sidesExtended[i + 1]
    const flipped = flipSide(side)
    const turn = getTurnFromTransition(flipped, nextSide)
    result.push(new Transition({from: flipped, to: nextSide, turn}))
  }
  return result
}
